import { gql } from '@apollo/client';

export const GET_HISTORICAL_DATA = gql`
    query Historic($stationCode: String!, $startDate: String!, $endDate: String!, $interval: QueryInterval) {
        historic(
            system: Qualle_Hidrometeorologia
            client: "secretaria-de-defesa-civil"
            stationCode: $stationCode
            startDate: $startDate
            endDate: $endDate
            interval: $interval
            opts: { ordenacao: ASC }
	    )
    }
`;
